/**
 * Reader-only longform layout for the existing immutable Tome I opening Story.
 *
 * The approved MASTER layout supplies the image and opening text. Only the
 * remaining frozen paragraphs flow in a full-width reading column below it.
 * Nothing is saved back to Editorial, and the same text is never duplicated.
 */
import { EditorialStoryRender } from "@/components/editorial/EditorialStoryMaster";
import { EditorialStoryFormattedParagraphV1 } from "./EditorialStoryFormattedParagraphV1";
import { splitTomeIntroLongform } from "../../lib/tomeIntroLongformV1.mjs";

export function TomeIntroLongformReaderV1({ block, mode = "desktop" }) {
  const { opening, continuation, finalQuote } = splitTomeIntroLongform(block);

  return (
    <div className="w-full" data-testid="tome-intro-longform-reader">
      <EditorialStoryRender block={opening} mode={mode} />
      {continuation.length > 0 && (
        <section
          className="mx-auto mt-10 w-full max-w-[680px] px-4 pb-6 sm:mt-14 sm:px-7 lg:mt-20"
          data-testid="tome-intro-longform-continuation"
        >
          <div className="space-y-5 text-[16px] leading-[1.9] text-[#3B241A] sm:text-[17px]">
            {continuation.map((paragraph, index) => {
              const authorHeading = typeof paragraph === "string"
                && paragraph.trim().toLocaleLowerCase("ru") === "от автора";
              return authorHeading ? (
                <h2 key={index}
                  className="pb-2 pt-2 font-serif text-[28px] font-normal leading-snug sm:text-[32px]"
                  data-testid="tome-intro-author-heading">
                  {paragraph}
                </h2>
              ) : (
                <EditorialStoryFormattedParagraphV1 key={index} text={paragraph}
                  className="whitespace-pre-wrap [overflow-wrap:anywhere]" />
              );
            })}
          </div>
          {finalQuote && (
            <blockquote
              className="mt-12 border-l border-[#7E8A3E] pl-5 font-serif text-[21px] italic leading-[1.55] text-[#3B241A] sm:mt-16 sm:text-[24px]"
              data-testid="tome-intro-longform-quote">
              {finalQuote}
            </blockquote>
          )}
        </section>
      )}
    </div>
  );
}
